import "./about.css";
import Projects from "../projects/projects";

function About() {
  return (
    <div id="about" className="container about-container">
      <Projects />
    </div>
  );
}
export default About;
